<template>
    <v-card flat style="border-top: 1px solid lightgray">
        <v-overlay :value="loadingPriceHistory">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-data-table
            :items-per-page="50"
            :footer-props="footerProps"
            :search="searchProductString"
            class="product-table"
            dense
            :headers="productPriceHistoryTableHeaders"
            :items="productPriceHistory"
        >
            <template
                v-for="h in productPriceHistoryTableHeaders"
                v-slot:[`header.${h.value}`]="{ header }"
                :class="'text-' + header.align"
            >
                {{ header.text ? t(header.text) : "" }}
            </template>
            <template v-slot:item="{ item, index }">
                <tr
                    :key="index"
                    @click="handleTableRowClick(item)"
                    :class="{
                        activeTableRow:
                            activeExtProductPrice &&
                            parseInt(item.ext_product_price_id) === parseInt(activeExtProductPrice.id) &&
                            $route.name !== 'ext-product-price-list'
                    }"
                >
                    <td>{{ item.ext_product_name }}</td>
                    <td>{{ item.ean }}</td>
                    <td style="text-align: end">{{ item.original_price }}</td>
                    <td style="text-align: end">{{ item.discount_price }}</td>
                    <td style="text-align: center">{{ formatDateTime(item.visited_at) }}</td>
                    <td>{{ item.shop_name }}</td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
    name: "ext-product-price-list",
    data() {
        return {
            footerProps: { "items-per-page-options": [25, 50, 100] },
            tableHeaders: []
        };
    },
    async mounted() {
        await this.fetchProductPriceHistory();

        if (this.products.length === 0 || this.shops.length === 0) {
            await this.getFrequentlyUsedQueries({ products: true, shops: true });
        }
    },
    computed: {
        ...mapState("ExtProductStore", [
            "productPriceHistory",
            "searchProductString",
            "activeExtProductPrice",
            "loadingPriceHistory",
            "productPriceHistoryTableHeaders"
        ]),
        ...mapState(["products", "shops"])
    },
    methods: {
        ...mapActions(["getFrequentlyUsedQueries"]),

        ...mapActions("ExtProductStore", ["fetchProductPriceHistory", "getProductPriceData"]),
        ...mapMutations("ExtProductStore", ["toggleDrawer"]),
        async handleTableRowClick(historyItem) {
            if (
                historyItem.ext_product_price_id !== this.activeExtProductPrice.id &&
                this.$route.params.extProductPriceId !== "new"
            ) {
                await this.$router.push({
                    name: "ext-product-price-view",
                    params: { extProductPriceId: historyItem.ext_product_price_id }
                });
                const param = {
                    id: this.$route.params.extProductPriceId
                };
                await this.getProductPriceData(param);
            }
        },
        formatDateTime(dateTimeString) {
            const dateTime = new Date(dateTimeString);

            const hours = dateTime
                .getHours()
                .toString()
                .padStart(2, "0");
            const minutes = dateTime
                .getMinutes()
                .toString()
                .padStart(2, "0");
            const day = dateTime
                .getDate()
                .toString()
                .padStart(2, "0");
            const month = (dateTime.getMonth() + 1).toString().padStart(2, "0");
            const year = dateTime.getFullYear().toString();

            return `${day}.${month}.${year}  -  ${hours}:${minutes}`;
        }
    }
};
</script>

<style scoped>
.activeTableRow {
    background-color: #f41823;
    color: #fff;
}

.activeTableRow:hover {
    background-color: #e11520 !important;
    color: #fff !important;
}

.dot {
    margin-top: 4px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}

.v-data-table-header {
    background-color: #f0f0f0;
}

::v-deep .v-data-table-header th {
    white-space: nowrap;
}

td {
    height: 25px !important;
}
</style>
